import { render, staticRenderFns } from "./zuimindetail.vue?vue&type=template&id=721a7e38&scoped=true&"
import script from "./zuimindetail.vue?vue&type=script&lang=js&"
export * from "./zuimindetail.vue?vue&type=script&lang=js&"
import style0 from "./zuimindetail.vue?vue&type=style&index=0&id=721a7e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721a7e38",
  null
  
)

export default component.exports